import { makeStyles } from "@material-ui/core/styles";
import styled from "styled-components";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    fontFamily: `${theme.typography.main}, Sans-serif, Arial`,
    width: "100%",
  },
  content: {
    width: "100%",
  },

  nameField: {
    "& .MuiFormLabel-root, & .MuiInputBase-root, & .MuiTypography-root": {
      fontFamily: `${theme.typography.main}, Sans-serif, Arial`,
      fontWeight: "bold",
      fontSize: "1.2rem",
      color: theme.palette.primary.textPrimary,
    },
  },

  btn: {
    width: "100%",
    marginTop: "1.5rem",
  },
  container: {
    width: "100%",
    height: "100%",
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(3),
  },
  paper: {
    // padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    width: "100%",
    position: "relative",
  },
  title: {
    color: theme.palette.primary.textPrimary,

    lineHeight: "2rem",
    fontWeight: "bold",
    fontSize: "1.2rem",
  },

  detail: { margin: "0 1rem ", width: "100%" },
  check: { margin: "0 1rem ", width: "10%" },
  fixedHeight: {
    height: 240,
  },
  breadcrumb: {
    margin: "1rem",
    fontFamily: `${theme.typography.main}, Sans-serif, Arial`,
    outline: "none !important",
    color: theme.palette.primary.backgroundSecondary,
  },
}));
export const Row = styled.div`
  padding-left: 1rem;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const Title = styled.p`
  font-weight: 600;
  font-size: 1rem;
`;
export const Detail = styled.p`
  display: flex;
  flex-direction: row;
  margin-left: 1rem;
`;

export const ControlBtnContainer = styled.div`
  display: flex;
  position: absolute;
  right: 0;
  top: 0.9rem;
`;

export const NameContainer = styled.div`
  padding: 1rem;
  background: ${({ theme }) => theme.palette.primary.backgroundSecondary};
  height: 4rem;
`;
